import React, { useEffect, useState } from "react";
import ReactLoading from "react-loading";
import SidebarMenu from "../../../Components/SidebarMenu";
import { Page } from "../../SignedOut/Cadastro/styles";
import { MenuItem, PageTitle, Option, Menu, OptionTitle } from "./styles";
import PageContainer from "../../../Components/PageContainer";
import Chart from "react-apexcharts";
import { PageOptions } from "./styles";
import api from "../../../Services/api";
import {
	optionsCompra,
	dataCompraSemanaDefault,
	dataUsoSemanaDefault,
	optionsEspecialidade,
	optionsUso,
	dataEspecialidadesDefault,
} from "./data";
import MenuMetricas from "../../../Components/MenuMetricas";
import MetricInforCard from "../../../Components/MetricInfoCard";

export default function MetricasCreditos() {
	const [graficoCompra, setGraficoCompra] = useState("semana");
	const [graficoUso, setGraficoUso] = useState("semana");
	const [dadosCompra, setDadosCompra] = useState(dataCompraSemanaDefault);
	const [dadosUso, setDadosUso] = useState(dataUsoSemanaDefault);
	const [loading, setLoading] = useState(true);
	const [creditosTotal, setCreditosTotal] = useState();
	const [usoTotal, setUsoTotal] = useState(0);
	const [usoMedio, setUsoMedio] = useState(0);
	const [usoMes, setUsoMes] = useState(0);
	const [compraSemana, setCompraSemana] = useState();
	const [compraMes, setCompraMes] = useState();
	const [compraAno, setCompraAno] = useState();
	const [totalParado, setTotalParado] = useState(0);
	const [tempoParado, setTempoParado] = useState(0);
	const [usoPorSemana, setUsoPorSemana] = useState();
	const [usoPorMes, setUsoPorMes] = useState();
	const [usoPorAno, setUsoPorAno] = useState();
	const [usoEspecialidades, setUsoEspecialidades] = useState(dataEspecialidadesDefault);

	// eslint-disable-next-line no-unused-vars
	const firstDateOfMonth = (date = new Date()) => new Date(date.getFullYear(), date.getMonth(), 1);

	// eslint-disable-next-line no-unused-vars
	const lastDateOfMonth = (date = new Date()) =>
		new Date(date.getFullYear(), date.getMonth() + 1, 0);

	const obterMetricasCreditos = async () => {
		try {
			const response = await api.get("/metricas-creditos");
			setCreditosTotal(response.data.creditosCompradosMesAtual ?? 0);
			setUsoTotal(response.data.creditosUsados ?? 0);
			setUsoMedio(response.data.creditosUsadosPorTitular ?? 0);
			setCompraSemana(response.data.creditosPorSemana);
			setDadosCompra([
				{
					name: "Créditos Utilizados",
					data: arrayTransform(response.data.creditosPorSemana),
				},
			]);
			setCompraMes(response.data.creditosPorMes);
			setCompraAno(response.data.creditosPorAno);
			setUsoMes(response.data.creditosUsadosMesAtual ?? 0);
			setTotalParado(response.data.creditosParados ?? 0);
			setTempoParado(response.data.tempoMedioCreditosParados ?? 0);
			setUsoPorSemana(response.data.creditosUsadosPorSemana);
			setDadosUso([
				{
					name: "Créditos Utilizados",
					data: arrayTransform(response.data.creditosUsadosPorSemana),
				},
			]);
			setUsoPorMes(response.data.creditosUsadosPorMes);
			setUsoPorAno(response.data.creditosUsadosPorAno);
			setUsoEspecialidades(
				response.data.creditosUsadosPorEspecialidade.map((item) => ({
					x: item.NO_especialidade,
					y: item.totalCreditos,
				}))
			);
			console.log(response.data);
		} catch (error) {
			console.log(error);
		} finally {
			setLoading(false);
		}
	}

	useEffect(() => {
		obterMetricasCreditos();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const arrayTransform = (series) => {
		const data = [];
		for (const [key, value] of Object.entries(series)) {
			data.push({ x: key, y: value });
		}
		return data;
	};

	// eslint-disable-next-line no-unused-vars
	const especialidadeArrayTransform = (series) => {
		const data = [];
		for (const [key, value] of Object.entries(series)) {
			data.push({ x: key, y: value });
		}
		return data;
	};

	const usoInfo = [
		{
			title: "Total",
			value: usoTotal,
			icon: (
				<svg
					width="28"
					height="49"
					viewBox="0 0 28 49"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M15.0565 21.4505C8.90859 19.8526 6.93151 18.2005 6.93151 15.6276C6.93151 12.6755 9.66693 10.6172 14.244 10.6172C19.0648 10.6172 20.8523 12.9193 21.0148 16.3047H27.0003C26.8107 11.6464 23.9669 7.36719 18.3065 5.98594V0.0546875H10.1815V5.90469C4.92734 7.04219 0.702343 10.4547 0.702343 15.6818C0.702343 21.938 5.87526 25.0526 13.4315 26.8672C20.2023 28.4922 21.5565 30.8755 21.5565 33.3943C21.5565 35.263 20.2294 38.2422 14.244 38.2422C8.66484 38.2422 6.47109 35.7505 6.17318 32.5547H0.214844C0.539844 38.4859 4.98151 41.8172 10.1815 42.9276V48.8047H18.3065V42.9818C23.5878 41.9797 27.7857 38.9193 27.7857 33.3672C27.7857 25.6755 21.2044 23.0484 15.0565 21.4505Z"
						fill="#4D4D4D"
					/>
				</svg>
			),
		},
		{
			title: "Média do mês por titular",
			value: usoMedio,
			icon: (
				<svg
					width="44"
					height="45"
					viewBox="0 0 44 45"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M22.318 25.1387C15.0868 25.1387 0.651367 28.7678 0.651367 35.972V44.097H43.9847V35.972C43.9847 28.7678 29.5493 25.1387 22.318 25.1387ZM38.8389 38.9512H5.7972V35.972C5.7972 34.2387 14.2743 30.2845 22.318 30.2845C30.3618 30.2845 38.8389 34.2387 38.8389 35.972V38.9512ZM22.318 22.4303C28.3035 22.4303 33.1514 17.5824 33.1514 11.597C33.1514 5.61159 28.3035 0.763672 22.318 0.763672C16.3326 0.763672 11.4847 5.61159 11.4847 11.597C11.4847 17.5824 16.3326 22.4303 22.318 22.4303ZM22.318 5.90951C25.4597 5.90951 28.0055 8.45534 28.0055 11.597C28.0055 14.7387 25.4597 17.2845 22.318 17.2845C19.1764 17.2845 16.6305 14.7387 16.6305 11.597C16.6305 8.45534 19.1764 5.90951 22.318 5.90951Z"
						fill="#4D4D4D"
					/>
				</svg>
			),
		},
		{
			title: "Mês atual",
			value: usoMes,
			icon: (
				<svg
					width="66"
					height="66"
					viewBox="0 0 66 66"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M54.4854 9.05534H51.777V3.63867H46.3604V9.05534H19.277V3.63867H13.8604V9.05534H11.152C8.17285 9.05534 5.73535 11.4928 5.73535 14.472V57.8053C5.73535 60.7845 8.17285 63.222 11.152 63.222H54.4854C57.4645 63.222 59.902 60.7845 59.902 57.8053V14.472C59.902 11.4928 57.4645 9.05534 54.4854 9.05534ZM54.4854 57.8053H11.152V22.597H54.4854V57.8053Z"
						fill="#4D4D4D"
					/>
				</svg>
			),
		},
	];

	const compraInfo = [
		{
			title: "Mês atual",
			value: creditosTotal,
			icon: (
				<svg
					width="28"
					height="49"
					viewBox="0 0 28 49"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M15.0565 21.4505C8.90859 19.8526 6.93151 18.2005 6.93151 15.6276C6.93151 12.6755 9.66693 10.6172 14.244 10.6172C19.0648 10.6172 20.8523 12.9193 21.0148 16.3047H27.0003C26.8107 11.6464 23.9669 7.36719 18.3065 5.98594V0.0546875H10.1815V5.90469C4.92734 7.04219 0.702343 10.4547 0.702343 15.6818C0.702343 21.938 5.87526 25.0526 13.4315 26.8672C20.2023 28.4922 21.5565 30.8755 21.5565 33.3943C21.5565 35.263 20.2294 38.2422 14.244 38.2422C8.66484 38.2422 6.47109 35.7505 6.17318 32.5547H0.214844C0.539844 38.4859 4.98151 41.8172 10.1815 42.9276V48.8047H18.3065V42.9818C23.5878 41.9797 27.7857 38.9193 27.7857 33.3672C27.7857 25.6755 21.2044 23.0484 15.0565 21.4505Z"
						fill="#4D4D4D"
					/>
				</svg>
			),
		},
	];

	const paradoInfo = [
		{
			title: "Total",
			value: totalParado,
			icon: (
				<svg
					width="28"
					height="49"
					viewBox="0 0 28 49"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M15.0565 21.4505C8.90859 19.8526 6.93151 18.2005 6.93151 15.6276C6.93151 12.6755 9.66693 10.6172 14.244 10.6172C19.0648 10.6172 20.8523 12.9193 21.0148 16.3047H27.0003C26.8107 11.6464 23.9669 7.36719 18.3065 5.98594V0.0546875H10.1815V5.90469C4.92734 7.04219 0.702343 10.4547 0.702343 15.6818C0.702343 21.938 5.87526 25.0526 13.4315 26.8672C20.2023 28.4922 21.5565 30.8755 21.5565 33.3943C21.5565 35.263 20.2294 38.2422 14.244 38.2422C8.66484 38.2422 6.47109 35.7505 6.17318 32.5547H0.214844C0.539844 38.4859 4.98151 41.8172 10.1815 42.9276V48.8047H18.3065V42.9818C23.5878 41.9797 27.7857 38.9193 27.7857 33.3672C27.7857 25.6755 21.2044 23.0484 15.0565 21.4505Z"
						fill="#4D4D4D"
					/>
				</svg>
			),
		},
	];

	const tempoInfo = [
		{
			title: "Tempo médio",
			value: `${tempoParado} dias`,
			icon: (
				<svg
					width="66"
					height="66"
					viewBox="0 0 66 66"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M32.9732 6.3457C18.0232 6.3457 5.91699 18.479 5.91699 33.429C5.91699 48.379 18.0232 60.5124 32.9732 60.5124C47.9503 60.5124 60.0837 48.379 60.0837 33.429C60.0837 18.479 47.9503 6.3457 32.9732 6.3457ZM41.9107 46.1853L30.292 34.5395V19.8874H35.7087V32.3186L45.7566 42.3665L41.9107 46.1853Z"
						fill="#4D4D4D"
					/>
				</svg>
			),
		},
	];

	function handleClickCompra(tipo, dados) {
		setGraficoCompra(tipo);

		setDadosCompra(dados);
	}

	function handleClickUso(tipo, dados) {
		setGraficoUso(tipo);
		setDadosUso(dados);
	}

	return (
		<Page>
			<SidebarMenu />
			<PageContainer>
				<PageTitle>Métricas</PageTitle>
				{loading ? (
					<div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "400px", width: "100%" }}>
						<ReactLoading type="spin" color="#663780" height={50} width={50} />
					</div>
				) : (
					<PageOptions>
						<MenuMetricas></MenuMetricas>

						<Option>
							<OptionTitle>Compra de créditos</OptionTitle>
							<MetricInforCard data={compraInfo}></MetricInforCard>
							<Menu>
								<MenuItem
									onClick={() =>
										handleClickCompra("semana", [
											{
												name: "Créditos Comprados",
												data: arrayTransform(compraSemana),
											},
										])
									}
									className={` ${graficoCompra === "semana" ? "bg-roxo text-white" : "bg-white text-roxo"
										}`}
								>
									Semana
								</MenuItem>
								<MenuItem
									onClick={() =>
										handleClickCompra("mes", [
											{
												name: "Créditos Comprados",
												data: arrayTransform(compraMes),
											},
										])
									}
									className={` ${graficoCompra === "mes" ? "bg-roxo text-white" : "bg-white text-roxo"
										}`}
								>
									Mês
								</MenuItem>
								<MenuItem
									onClick={() =>
										handleClickCompra("ano", [
											{
												name: "Créditos Comprados",
												data: arrayTransform(compraAno),
											},
										])
									}
									className={` ${graficoCompra === "ano" ? "bg-roxo text-white" : "bg-white text-roxo"
										}`}
								>
									Ano
								</MenuItem>
							</Menu>
							<Chart
								options={optionsCompra.options}
								series={dadosCompra}
								type="line"
								height={350}
							></Chart>
						</Option>
						<Option>
							<OptionTitle>Uso de créditos</OptionTitle>
							<MetricInforCard data={usoInfo}></MetricInforCard>
							<Menu>
								<MenuItem
									onClick={() =>
										handleClickUso("semana", [
											{
												name: "Créditos Utilizados",
												data: arrayTransform(usoPorSemana),
											},
										])
									}
									className={` ${graficoUso === "semana" ? "bg-roxo text-white" : "bg-white text-roxo"
										}`}
								>
									Semana
								</MenuItem>
								<MenuItem
									onClick={() =>
										handleClickUso("mes", [
											{
												name: "Créditos Utilizados",
												data: arrayTransform(usoPorMes),
											},
										])
									}
									className={` ${graficoUso === "mes" ? "bg-roxo text-white" : "bg-white text-roxo"}`}
								>
									Mês
								</MenuItem>
								<MenuItem
									onClick={() =>
										handleClickUso("ano", [
											{
												name: "Créditos Utilizados",
												data: arrayTransform(usoPorAno),
											},
										])
									}
									className={` ${graficoUso === "ano" ? "bg-roxo text-white" : "bg-white text-roxo"}`}
								>
									Ano
								</MenuItem>
							</Menu>
							<Chart options={optionsUso.options} series={dadosUso} type="line" height={350}></Chart>
						</Option>
						<Option>
							<OptionTitle>Uso por especialidade</OptionTitle>
							<Chart
								options={optionsEspecialidade.options}
								series={[
									{
										name: "Créditos Utilizados",
										data: usoEspecialidades,
									},
								]}
								type="bar"
								height={350}
							></Chart>
						</Option>
						<Option>
							<OptionTitle>Créditos em estoque</OptionTitle>
							<MetricInforCard data={paradoInfo}></MetricInforCard>
						</Option>
						<Option>
							<OptionTitle>Tempo de créditos em estoque</OptionTitle>
							<MetricInforCard data={tempoInfo}></MetricInforCard>
						</Option>
					</PageOptions>
				)}
			</PageContainer>
		</Page>
	);
}
